import React from "react";
import Sidebar from "../../components/mainpage/subcomponent/Sidebar";
import Users from "./Users";
import Missing from "../../Missing";

const AdminPanel = () => {
  const role = 'admin';
  return (
    <>
      {role === "admin" ? (
        <>
          <Sidebar />
          <div className="container-fluid">
            <Users />
          </div>
        </>
      ) : (
        <Missing />
      )}
    </>
  );
};

export default AdminPanel;
